// v2 Feb 23
// v3 May 23
// v4 June 23

// formatdatetime

import { isNull, isEqual, isArray } from "lodash";
import showdown from 'showdown';

//import 'semantic-ui-css/semantic.min.css'
import { Button , Popup } from 'semantic-ui-react'

import sanitizeHtml from 'sanitize-html';

import { htmlToText } from 'html-to-text';





export const getParam = (nameParam, props) => {

    let value = null;

    if (props){
        if (props.location){
            const queryparams = getQueryStringParams(props.location.search);
            if (queryparams.hasOwnProperty(nameParam)){
                value = queryparams[nameParam];
            }
        }
        if (props.params){
            if (props.params.hasOwnProperty(nameParam)){
                value = props.params[nameParam];
            }
        }
        if (props.hasOwnProperty(nameParam)){
            value = props[nameParam];
        }
    }

   return value;
};


export const  getQueryStringParams = query => {
    return query
        ? (/^[?#]/.test(query) ? query.slice(1) : query)
            .split('&')
            .reduce((params, param) => {
                    let [key, value] = param.split('=');
                    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                    return params;
                }, {}
            )
        : {}
};



export const  cloneObject = object => {

    return JSON.parse(JSON.stringify(object));

};


export const  HowToText = (howtotext, model) => {

    if (!isArray(howtotext)){
        return <span>{howtotext}</span>
    }


    return (
        howtotext.map((block, posBlock) => 
            {
                return (

                    <p key={posBlock}>

                        {
                            block.parts.map(
                                (part, posPart) => 
                                    {

                                        if (part.entity){

                                            let Entity = null;
                                            let EntityContent = null;
                                            if (part.entity in model.entities){
                                                Entity = model.entities[part.entity];
                                                if (Entity.definition){
                                                    EntityContent = Entity.definition;
                                                }
                                                if (Entity.howtouse){
                                                    EntityContent = Entity.howtouse;
                                                }
                
                                            }
                                        
                                            return(
                
                                               <Popup
                                                    key={posPart}
                                                    trigger={<Button>{part.text}</Button>}
                                                    header={Entity.label}                                    
                                                    content={EntityContent}
                                                />                    
                                           )
                                        }

                                        return (
                                            <span key={posPart}>{part.text}</span>
                                        )
                                    }
                            )
                        }



                    </p>
                )
            }
        )
    )

};

export const  hasProperty = (object,property) => {

    if (object.hasOwnProperty(property)){
        if (object[property] !== null ){
            if (object[property].toString().trim() != ''){
                return true
            }
        }
    }

    return false;

};

export const  formatDate = (inDate = null,outFormat = "xsd") => {

    var d;

    if (isNull(inDate)){
        d = new Date();
    } else {
        d = new Date(inDate)
    }

    var month = '' + (d.getMonth() + 1)
    var day = '' + d.getDate()
    var year = d.getFullYear();

    var hours = '' + d.getHours();
    var minutes = '' + d.getMinutes();
    var seconds = '' + d.getSeconds();


    if (month.length < 2){
        month = '0' + month;
    }

    if (day.length < 2){
        day = '0' + day;
    }

    if (hours.length < 2){
        hours = '0' + hours;
    }

    if (minutes.length < 2){
        minutes = '0' + minutes;
    }
    if (seconds.length < 2){
        seconds = '0' + seconds;
    }


    switch (outFormat){
        case 'dmy':
            return day + '/' + month + '/' + year;
        case 'dmy hms':
            return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;   
        case 'xsd':
        default:
            return [year, month, day].join('-');

    }
};




export const  formatText = (inText = null) => {

//    const arrParts = inText.split(/[\r\n]+/);

    if (isNull(inText)){
        return (<div/>)
    }

    const arrParts = inText.split(/[\r\n]/);

    if (arrParts.length < 2){
        return inText;
    }
    return(
    <div>
        {
            arrParts.map(
                (Part, posPart) => 
                {
                    switch (Part){
                        case '':
                            return <br key={posPart}/> 
                            break;
                    }
                    return(
                        <div key={posPart}>{Part}</div>
                    )
                })
        }
    </div>
    )

};

export const  htmlEncode = (rawStr) => {

    var encodedStr = rawStr.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
        return '&#'+i.charCodeAt(0)+';';
     });
     return encodedStr;
};

export const  dotField = (inString, boolWrap=false, chars=200) => {

    let outString = inString;

    outString = MarkDownToHtml(outString);
    outString = HtmlToText(outString);
    outString = truncate(inString,chars);
    outString = htmlEncode(outString);

    if (boolWrap){
        outString = wrap(outString);
    }

    return outString;
};

export const  wrap= (Text, LineLength = 40, BreakChars = "<br/>") => {

    let strOut = '';
    let strLine = '';

    let arrSplit = Text.split(' ');
// add spaces where any word is longer than the line length

    let arrWords = [];

    let i = 0;
    for(i = 0; i < arrSplit.length; i++){
        let Word = arrSplit[i];
        while (Word.length > LineLength) {
            arrWords.push(Word.substr(0,LineLength-1));
            Word = Word.substr(LineLength)
        }
        arrWords.push(Word);
    }



    for(i = 0; i < arrWords.length; i++){
        let Word = arrWords[i];
        if ((strLine.length + Word.length) > parseInt(LineLength)){
            if (strLine.length > 0){
                if (strOut.length > 0){
                    strOut += BreakChars;
                }
                strOut += strLine;
                strLine = '';
            }
        }
        if (strLine.length > 0){
            strLine += ' ';
        }
        strLine += Word;
    }
    if (strLine.length > 0){
        if (strOut.length > 0){
            strOut += BreakChars;
        }
        strOut += strLine;
        strLine = '';
    }

    return strOut;
};

export const  truncate= (str, max=50, suffix='...') => {


    if (!str){
        return '';
    };

    if (str.length < max){
        return str;
     }
     
     return `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))} ${suffix}`;

};


//export const sanitize = (dirty, options) => {
//    return (sanitizeHtml(dirty))
//};
  
const htmlSanitizeDefaultOptions = {
    allowedTags: ['b', 'i', 'em', 'strong', 'p', 'br', 'a', 'ul', 'ol', 'li'],
    allowedAttributes: {
        'a': ['href', 'title', 'target']
    },
    allowedSchemes: ['http', 'https', 'mailto']
};
const htmlSanitizeNoTagsOptions = {
    allowedTags: []
};

// Protect against ReDoS and DoS attacks
const MAX_HTML_INPUT_SIZE = 100000; // 100KB limit

const htmlsanitize = (dirty, options) => {
    // Check input size
    if (typeof dirty === 'string' && dirty.length > MAX_HTML_INPUT_SIZE) {
        console.warn('HTML input exceeds maximum size limit');
        dirty = dirty.substring(0, MAX_HTML_INPUT_SIZE);
    }
    
    return {
        __html: sanitizeHtml(
          dirty, 
          { ...htmlSanitizeDefaultOptions, ...options }
        )
    };
};
  

export  const SanitizeHTML = ({ html, options = {}, ...props}) => (
    
    <div dangerouslySetInnerHTML={htmlsanitize(html, options)}  {...props} />
);

const htmlNoTags = (dirty, options = {}) => {
    let txt = 
    sanitizeHtml(
      dirty, 
      htmlSanitizeNoTagsOptions
    )
    return txt;
};
  

export  const NoTagsHTML = (html) => {
    return htmlNoTags(html).toString();
};



export const HtmlToText = (html) => {
        
    const options = {};
    const text = htmlToText(html, options);

    return (text)
};

export const MarkDownToHtml = (text) => {
    const converter = new showdown.Converter();
    const html = converter.makeHtml(text);
    return (html);
}


export const round = (value,precision) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
};


// ====== Graphviz/DOT Visualization Helper Functions ======

export const isExistingEdge = (dotEdges, idNodeFrom, idNodeTo) => {
    let boolIsExistingEdge = false;

    for (let idEdge in dotEdges){
        let dotEdge = dotEdges[idEdge];
        if (dotEdge.FromNode){
            if (dotEdge.ToNode){

                if (dotEdge.FromNode.idNode == idNodeFrom){
                    if (dotEdge.ToNode.idNode == idNodeTo){
                        boolIsExistingEdge = true;
                    }
                }

                if (dotEdge.FromNode.idNode == idNodeTo){
                    if (dotEdge.ToNode.idNode == idNodeFrom){
                        boolIsExistingEdge = true;
                    }
                }
            }
        }

    }

    return boolIsExistingEdge;
};

export const makeInvisNode = (idNode) => {
    let dot = `${idNode} [label="invis", style="invis"];
  `;

    return dot;
};

export const makeInvisEdge = (idNodeFrom, idNodeTo) => {
    let dot = `${idNodeFrom} -> ${idNodeTo} [label="invis", style="invis"];
    `;

    return dot;
};

export const makeEdge = (Label, FromNode, ToNode, style='solid', LabelPos = 'tail', LabelLength=100, LineLength=10, EdgeAtts = "", FromPort=null, ToPort=null) => {
    let dotEdge = {}
    dotEdge.FromNode = FromNode;
    dotEdge.ToNode = ToNode;
    dotEdge.Label = Label;
    if (isNull(dotEdge.Label)){
        dotEdge.Label = "";
    }

    if (dotEdge.Label){
        if (dotEdge.Label.length > LabelLength){
            dotEdge.Label = dotEdge.Label.substring(1, LabelLength) + '...';
        }
        dotEdge.Label = wrap(dotEdge.Label,LineLength,'\\l') + '\\l';
    }


    let dotLabel = '';
    if (Label != ""){
        switch (LabelPos){
            case 'centre':
                dotLabel = `xlabel="`;
                break;
            case 'head':
                dotLabel = `headlabel="`;
                break;
            default:            
                dotLabel = `taillabel="`;
                break;
        }
        dotLabel += `${dotEdge.Label}"`
    }

    dotEdge.EdgeFrom = FromNode.idNode;
    if (FromPort){
        dotEdge.EdgeFrom = `${dotEdge.EdgeFrom}:${FromPort}`;
    }
    dotEdge.EdgeTo = ToNode.idNode;
    if (ToPort){
        dotEdge.EdgeTo = `${dotEdge.EdgeTo}:${ToPort}`;
    }

    dotEdge.dot = `${dotEdge.EdgeFrom} -> ${dotEdge.EdgeTo} [style="${style}"  ${dotLabel} ${EdgeAtts}];`;

    return dotEdge;
};

export const makeNodeDot = (Node, boolPosition = false, maxRanks=null, dotLanes=null) => {
    let posX = 0;
    let posY = 0;

    if (boolPosition){

        if ("Rank" in Node){
            posY = ( maxRanks - Node.Rank);
            posY = posY * 1.2;
        }
        if ("Lane" in Node){
            for (let posLane=1; posLane<Node.Lane; posLane++){
                if (posLane in dotLanes){
                    posX += Number(dotLanes[posLane].maxParallels);
                }
            }
            posX += Number(Node.Parallel) - 1;
        }
        posX = posX * 2.5;

        posX = round(posX,2);
        posY = round(posY,2);

        Node.posX = posX;
        Node.posY = posY;
    }

    if (Node.dot){
        return Node.dot;
    }

   let dot = `${Node.idNode} [`;

    if (boolPosition){
        dot += `pos="${posX},${posY}!", `;
    }

    let Label = Node.label;
    Label = Label.trim()

    
    if (Label.startsWith("<<")){
        dot += ` label=${Label}`;
    } else {
        dot += ` label="${Node.label}"`;
    }
    
    if (Node.image){
        dot += `, image="${Node.image}" `
    }
    else{
        dot += `, shape=${Node.shape} `
    }

    if (Node.fixedsize){
        dot += `, fixedsize=true`;
    }

    if (Node.height){
        dot += `, height=${Node.height}`;
    }
    if (Node.width){
        dot += `, width=${Node.width}`;
    }
    if (Node.style){
        dot += `, style="${Node.style}"`;
    }

    if (Node.color){
        dot += `, fillcolor="${Node.color}"`;
    }

    if (Node.URL){
        dot += `, URL="${Node.URL}" `;
    }
    else{
        dot += `, URL="${Node.idNode}" `;
    }

    dot += `]; `;

    return dot;
};

